<template>
  <div class="dialog-related-review">
    <div class="wrap-form">
      <div class="kh-table kh-table-default kh-table-border">
        <table cellspacing="0">
          <thead>
          <tr>
            <th><div class="kh-table-cell">单位/专家</div></th>
            <th><div class="kh-table-cell">联系电话</div></th>
          </tr>
          </thead>
          <tbody>
          <tr class="kh-table-row" v-if="relatedList.length>0" v-for="(item, index) in relatedList" :key="index">
            <td><div class="kh-table-cell">{{item.name}}</div></td>
            <td><div class="kh-table-cell">{{item.phone}}</div></td>
          </tr>
          <tr class="kh-table-row" v-if="relatedList.length===0">
            <td colspan="2"><div class="kh-table-cell">不存在需要预警的专家/单位</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Spin size="large" fix v-if="dialogLoading"></Spin>
  </div>
</template>

<script>
export default {
  name: 'relatedReview',
  props: {
    query: ''
  },
  data () {
    return {
      dialogLoading: true,
      relatedList: []
    }
  },
  mounted () {
    this.fetchRelatedInfo();
  },
  methods: {
    fetchRelatedInfo () {
      const _self = this;
      _self.dialogLoading = true;
      _self.fetch('/exp/expReviewInfo/queryContactInfo/' + _self.query).then(res => {
        _self.dialogLoading = false;
        _self.relatedList = res.data;
      }).catch(() => {
        _self.dialogLoading = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-related-review {
    .kh-table {
      table {
        table-layout: auto;
        width: 100%;
        th {
          border-top: 1px solid #e8eaec;
          &:first-child {
            border-left: 1px solid #e8eaec;
          }
        }
        td {
          height: 35px;
          &:first-child {
            border-left: 1px solid #e8eaec;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/thesisManage/relatedReview.vue